module.exports = function() {
  return new Worker(__webpack_public_path__ + "02c883dadd5eca789d03.worker.js");
};